import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import LoadableDuperbrowseContext from '../../../../../contexts/LoadableDuperbrowseContext';
import EmptyState from '../../_partials/EmptyState';
import JournalFeedThumb from './JournalFeedThumb';

import s from './JournalsList.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
}

const JournalsList: React.FC<Props> = ({ items, streamId }) => {
  const { t } = useTranslation();

  if (!items.length) {
    return <EmptyState view="large" postType="journal" />;
  }

  return (
    <div className={s['root']}>
      <LoadableDuperbrowseContext
        streamId={streamId}
        parent={{ title: t('navigation.route.posts') }}
      >
        {items.map((item, index) => (
          <BiLoggerContextProvider
            key={`journal-${index}-${item.deviationId}`}
            value={{
              rank: index,
            }}
          >
            <JournalFeedThumb className={s['item']} item={item} />
          </BiLoggerContextProvider>
        ))}
      </LoadableDuperbrowseContext>
    </div>
  );
};
JournalsList.displayName = 'JournalsList';

export default JournalsList;
